module.exports = __webpack_public_path__ + "static/media/memoriesLogo.4b9dc077.png";